import React, { useMemo } from 'react';

import { useMarketFillsQuery } from 'api/queries/fillQueries';

import MyTradesTable from './MyTradesTable';

type Props = {
  marketFilter: string | undefined;
  onSelectOrder: (orderId: string, highlightFillId: string) => void;
};

export default function MyTradeHistory({ marketFilter, onSelectOrder }: Props) {
  const { data: trades, isFetching } = useMarketFillsQuery(
    marketFilter ?? false
  );

  const tradesTransformed = useMemo(
    () =>
      trades?.map(fill => ({
        ...fill,
        baseAssetSymbol: fill.market.split('-')[0],
      })) || [],
    [trades]
  );

  return (
    <MyTradesTable
      loading={isFetching}
      onSelectOrder={onSelectOrder}
      trades={tradesTransformed}
      appearAnimationEnabled
    />
  );
}
